module.exports = __webpack_public_path__ + "media/info_team.aa39b888.mp4";